<template>
  <el-dialog
    title="设置跟进提醒"
    :visible.sync="dialogVisible"
    width="400px"
    :close-on-click-modal="false"
    @close="onClose">
    <el-form label-width="80px" size="small">
      <el-form-item label="客户">
        <span>{{ contactName }}</span>
      </el-form-item>
      <el-form-item label="提醒时间">
        <el-date-picker
          v-model="remindTime"
          type="datetime"
          placeholder="选择提醒时间"
          :picker-options="pickerOptions"
          value-format="timestamp">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="note"
          type="textarea"
          :rows="2"
          placeholder="跟进备注（选填）">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="onClose">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="onConfirm">确认设置</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createReminder } from '../../api/user.js'

export default {
  name: 'ReminderDialog',
  props: {
    visible: { type: Boolean, default: false },
    vid: { type: String, default: '' },
    userID: { type: String, default: '' },
    contactName: { type: String, default: '' }
  },
  emits: ['close', 'saved'],
  data() {
    return {
      dialogVisible: false,
      remindTime: null,
      note: '',
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7 // 不能选过去的时间
        }
      }
    }
  },
  watch: {
    visible(val) { this.dialogVisible = val; }
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    async onConfirm() {
      if (!this.remindTime) {
        this.$message.warning('请选择提醒时间');
        return;
      }
      this.loading = true;
      try {
        await createReminder({
          vid: this.vid,
          userID: this.userID,
          remindAt: Math.floor(this.remindTime / 1000),
          note: this.note
        });
        this.$message.success('提醒设置成功');
        this.$emit('saved');
        this.onClose();
      } catch (e) {
        this.$message.error('设置失败: ' + (e.message || e));
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
